/**
 * Find translation in translations array
 * @param {Object} item 
 * @param {Object} language 
 */
const findTranslation = (item, language) => {
    if(language && item.translations) {

        return item.translations.findIndex(item => (
            item.language_id == language.id || item.iso === language.iso
        ))
    }
    return -1;
}

/**
 * Translation Manipulation plugin 
 * @type {{install(*, *): void}}
 */
const TranslationPlugin = {

    install(app, options) {

        /**
         * Find or create item translation
         * 
         * @param {Object} item Model with translations array
         * @param {Object} language Language with id 
         * @param {Object} empty ModelTranslation if translation not found in array this item will pushed
         */
        app.config.globalProperties.$findOrCreateTranslation = (item, language, empty={}) => {
            
            try{
                if(!language.id || !item) {

                    return {};
                }
                const index = findTranslation(item, language);

                if(index === -1) {
    
                    // will Create a new translation
                    const length = item.translations.push({ ...empty, language_id: language.id })
                    return item.translations[length-1];
    
                } else {
        
                    // return translation
                    return item.translations[index];
                }
            } catch(e) {
                console.error('TRANSLATION_PLUGIN::', e, 'in findOrCreateTranslation');
                return {}
            }
            
        }

        /**
         * Find item translation in translation or array translations
         * 
         * @param {Object} item Model with translation property or translations array
         * @param {Object} language Language with id 
         */
        app.config.globalProperties.$findTranslation = (item, language) => {
            try{
                if (item.translation) {

                    return item.translation;

                } else if (item.translations) {
                    const index = findTranslation(item, language);
                    if(index >= 0) {
                        
                        return item.translations[index];

                    } else {

                        return {}
                    }
                } else {
                    return {}
                }
            } catch (e) {
                console.error('TRANSLATION_PLUGIN::', e, 'in findTranslation');
                return {}
            }            
        }
    }
}

export default TranslationPlugin;